import { API } from './resources'

export default {
  getProjectsToSpamReview: (data) => {
    return API.post('/projects/spam-review', data)
  },
  updateSpamProjectStatus: (data) => {
    return API.put('/projects/spam-review/update-status', data)
  },
  deleteSpamProjects: (data) => {
    return API.delete('/projects/spam-review/delete', { data: data })
  },
  getSpamProjectCounts: (data) => {
    return API.post('/projects/spam-review/count', data)
  }
}
